import { Field, FormikProps } from "formik";
import * as React from "react";
import bootstrapStyles from "../../css/bootstrap.module.css";
import { FormValues } from "../../support/FormValues";
import { FieldCustomMask } from "../../components/FieldCustomMask";
import FieldSelect from "../../components/FieldSelect";
import { AccountTypeEnum } from "../../support/AccountTypeEnum";
import { FieldNameEnum } from "../../support/FieldNameEnum";

interface SimpleProps {
  formikBag: FormikProps<FormValues>;
}

const simpleToOptionsOver2Years = [
  AccountTypeEnum.SimpleIRA,
  AccountTypeEnum.SEPIRA,
  AccountTypeEnum.TraditionalIRA
];

export const Simple = ({ formikBag: { values } }: SimpleProps) => {
  return (
    <React.Fragment>
      <div className={bootstrapStyles.row}>
        <div className={bootstrapStyles["col-md-6"]}>
          <Field
            type="text"
            spellCheck="false"
            name={FieldNameEnum.initialFundingDate}
            label="Approximately, when did you first fund this account?"
            mask="date"
            component={FieldCustomMask}
            style={{
              width: "110px"
            }}
          />
        </div>
      </div>
      <div className={bootstrapStyles.row}>
        <div className={bootstrapStyles["col-md-12"]}>
          <hr />
        </div>
      </div>
      <div className={bootstrapStyles.row}>
        <div className={bootstrapStyles["col-md-6"]}>
          <Field
            name={FieldNameEnum.toAccountType}
            label="Transfer Account To"
            options={simpleToOptionsOver2Years}
            component={FieldSelect}
            removeDefaultSelectOption
          />
        </div>
      </div>
    </React.Fragment>
  );
};
